<template>
  <div class="container">
        <div class="title-container">
            <span>{{ $t('cgu.title') }}</span>
        </div>
        <div class="content-container">
            <div v-html="staticTranslations.part1"></div>
            <div v-html="staticTranslations.part2"></div>
            <div v-html="staticTranslations.part3"></div>
            <div v-html="staticTranslations.part4"></div>
            <div v-html="staticTranslations.part5"></div>
            <div v-html="staticTranslations.part6"></div>
            <div v-html="staticTranslations.part7"></div>
            <div v-html="staticTranslations.part8"></div>
            <div v-html="staticTranslations.part9"></div>
            <div v-html="staticTranslations.part10"></div>
            <div v-html="staticTranslations.part11"></div>
            <div v-html="staticTranslations.part12"></div>
            <div v-html="staticTranslations.part13"></div>
            <div v-html="staticTranslations.part14"></div>
            <div v-html="staticTranslations.part15"></div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import frTranslations from '@/locales/fr.json';

export default defineComponent({
    name: 'CguPage',
    computed: {
        staticTranslations() {
            const cguTranslations = frTranslations.filter(t => t.nom.startsWith('cgu.content.'));
            return {
                part1: cguTranslations.find(t => t.nom === 'cgu.content.part1')?.libelle || '',
                part2: cguTranslations.find(t => t.nom === 'cgu.content.part2')?.libelle || '',
                part3: cguTranslations.find(t => t.nom === 'cgu.content.part3')?.libelle || '',
                part4: cguTranslations.find(t => t.nom === 'cgu.content.part4')?.libelle || '',
                part5: cguTranslations.find(t => t.nom === 'cgu.content.part5')?.libelle || '',
                part6: cguTranslations.find(t => t.nom === 'cgu.content.part6')?.libelle || '',
                part7: cguTranslations.find(t => t.nom === 'cgu.content.part7')?.libelle || '',
                part8: cguTranslations.find(t => t.nom === 'cgu.content.part8')?.libelle || '',
                part9: cguTranslations.find(t => t.nom === 'cgu.content.part9')?.libelle || '',
                part10: cguTranslations.find(t => t.nom === 'cgu.content.part10')?.libelle || '',
                part11: cguTranslations.find(t => t.nom === 'cgu.content.part11')?.libelle || '',
                part12: cguTranslations.find(t => t.nom === 'cgu.content.part12')?.libelle || '',
                part13: cguTranslations.find(t => t.nom === 'cgu.content.part13')?.libelle || '',
                part14: cguTranslations.find(t => t.nom === 'cgu.content.part14')?.libelle || '',
                part15: cguTranslations.find(t => t.nom === 'cgu.content.part15')?.libelle || '',
            };
        }
    }
});
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px 24px 0 24px;
}

.title-container {
    color: var(--color-principal);
    font-size: var(--font-size-large);
    font-weight: var(--font-weight-600);
    margin-bottom: 15px;
}

.content-container {
    margin-top: 8px;
    padding: 40px 40px;
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
}
</style>
